import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../openapi';

@Pipe({
  name: 'applicationNotesPlaceholder',
  standalone: true
})
export class ApplicationNotesPlaceholderPipe implements PipeTransform {
  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case application?.service?.url === '/lokalizacja-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi': {
        return 'Wpisz tu uzasadnienie';
      }
      default: {
        return 'Wpisz tu czego dotyczy zgłoszenie';
      }
    }
  }
}
